var _rect, _path, _path2, _path3, _rect2, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUiUx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    id: "designing",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 21,
    x: 0.495,
    y: 4.501,
    fill: "#b0b0b0",
    rx: 2,
    ry: 2,
    className: "colorafaeb3 svgShape"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M31.495,21.5v2a2.006,2.006,0,0,1-2,2h-27a2.006,2.006,0,0,1-2-2v-2Z",
    className: "colore0e0e2 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0b0b0",
    d: "M22.495,31.5h-13l1.6-1.2a6,6,0,0,0,2.4-4.8h5a6,6,0,0,0,2.4,4.8Z",
    className: "colorafaeb3 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M11.755 18.512a3.98 3.98 0 0 1-.425-.023A3.449 3.449 0 0 1 8.9 17.12 4.685 4.685 0 0 1 8 14.528a10.976 10.976 0 0 1 .028-1.272 5.413 5.413 0 0 0-.1-1.912A2.894 2.894 0 0 0 6.414 9.611a3.49 3.49 0 0 0-2.7-.166.5.5 0 1 1-.342-.939 4.507 4.507 0 0 1 3.484.209 3.88 3.88 0 0 1 2.022 2.334 6.235 6.235 0 0 1 .142 2.269 10.337 10.337 0 0 0-.028 1.157 3.693 3.693 0 0 0 .7 2.042 2.481 2.481 0 0 0 1.746.979 3.492 3.492 0 0 0 2.58-.836.5.5 0 0 1 .648.762A4.57 4.57 0 0 1 11.755 18.512zM31.505 2.5a1.952 1.952 0 0 1-.59 1.41l-.7.71-2.83-2.83.71-.7a1.974 1.974 0 0 1 2.82 0A1.952 1.952 0 0 1 31.505 2.5z",
    className: "colore0e0e2 svgShape"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 15.005,
    height: 4.002,
    x: 15.993,
    y: 6.51,
    fill: "#999999",
    transform: "rotate(-45 23.494 8.511)",
    className: "colored4569 svgShape"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#d2d2d2",
    points: "19.605 15.231 16.075 15.941 16.775 12.401 19.605 15.231",
    className: "colorf5bdaf svgShape"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiUx);
export default __webpack_public_path__ + "static/media/ui_ux.eb574ce90dbfad30d6854319202d8c28.svg";
export { ForwardRef as ReactComponent };